__turbopack_context__.v({
  "accordionSlideOverwrite": "tabs-module-scss-module__sIb2xG__accordionSlideOverwrite",
  "active": "tabs-module-scss-module__sIb2xG__active",
  "fadeIn": "tabs-module-scss-module__sIb2xG__fadeIn",
  "fadeOut": "tabs-module-scss-module__sIb2xG__fadeOut",
  "scaleIn": "tabs-module-scss-module__sIb2xG__scaleIn",
  "scaleOut": "tabs-module-scss-module__sIb2xG__scaleOut",
  "tabs": "tabs-module-scss-module__sIb2xG__tabs",
  "tabsContent": "tabs-module-scss-module__sIb2xG__tabsContent",
  "tabsList": "tabs-module-scss-module__sIb2xG__tabsList",
  "tabsTrigger": "tabs-module-scss-module__sIb2xG__tabsTrigger",
  "zoomIn": "tabs-module-scss-module__sIb2xG__zoomIn",
  "zoomOut": "tabs-module-scss-module__sIb2xG__zoomOut",
});
